import { join, setPaginationParams, tryParse, DEFAULT_NAVIGATION_STATE, TAB_NAMES, FILTER_STATE_CHANGED_EVENT_NAME, rangeBasePath, CAASContentOverviewSlotName } from '@pes-ui/utils';
import { h } from '@stencil/core';
import isEmpty from 'lodash/isEmpty';
import { trackFilterAnalytics, fetchSprykerFilters, } from '../../globals/utils/normalizeFiltersData';
import { filterReset, getBaseUrl, getCountry, getFilterProductsUrl, getLanguage, getLocaleWithV3, getPbsFilterProductsUrl, getRangeFilterUrl, getSelectedNodeIdFromUrl, parseRichText, setNavigationFilterPath, getPaginationParams, getAnalyticsPageLoadData, } from '../../globals/utils/helpers';
import { isBrowser, isMobile } from '../../globals/utils';
import { pageParam } from '../category-subcategory-listing/constants';
import { calculateCurrentNodeParams, getCurrentReference, getRangeNodesIds, } from '../product-range/utils/range-helpers';
import { getData } from '../../globals/http';
export class RangeTabs {
  constructor() {
    this.handlePopState = () => {
      var _a, _b;
      if (this.isPBS)
        return;
      const { offset, productsPerPage } = this.getPaginationParamsWithDefaults;
      this.selectedPage = Math.floor(offset / productsPerPage) + 1;
      const changedFilterUrl = getRangeFilterUrl(this.filterNodeId, (_b = (_a = this.tabs) === null || _a === void 0 ? void 0 : _a.products) === null || _b === void 0 ? void 0 : _b.filtersUrl, this.localeCode);
      this.nodeOrSubCatId = getSelectedNodeIdFromUrl(this.initialNodeId);
      this.loadFilters(changedFilterUrl);
    };
    this.renderPresentationTab = (slot = null) => {
      var _a;
      if (!((_a = this.tabs) === null || _a === void 0 ? void 0 : _a.presentation))
        return null;
      return (h("pes-range-presentation-tab", { presentation: this.tabs.presentation }, slot));
    };
    this.renderWebinarsAndResources = () => {
      var _a;
      return (((_a = this.tabs) === null || _a === void 0 ? void 0 : _a.webinarsAndResources) && (h("pes-range-webinars-and-resources-tab", { webinarAndResources: this.tabs.webinarsAndResources })));
    };
    this.renderProductsTab = () => (h("pes-range-products-tab", { labels: {
        commonFiltersFilterBy: this.commonFiltersFilterBy,
        facetButtonResetAllLabel: this.facetButtonResetAllLabel,
        rangeProductsFiltersLabel: this.rangeProductsFiltersLabel,
        facetButtonViewMoreFilters: this.facetButtonViewMoreFilters,
        facetButtonViewLessFilters: this.facetButtonViewLessFilters,
        previousLabel: this.previousLabel,
        nextLabel: this.nextLabel,
        labelValue: this.pageLabel,
        viewProductsLabel: this.viewProductsLabel,
        rangeProductLabel: this.rangeProductLabel,
        appProductsLabel: this.appProductsLabel,
        numberProductsOfAllProductsLabel: this.numberProductsOfAllProductsLabel,
        noResultsClearLink: this.noResultsClearLink,
        noResultsHeader: this.noResultsHeader,
        noResultsMessage: this.noResultsMessage,
        viewMoreLabel: this.viewMoreLabel,
        viewLessLabel: this.viewLessLabel,
        loadMoreLabel: this.loadMoreLabel,
        loadPreviousLabel: this.loadPreviousLabel,
      }, rangeBanner: this.rangeBanner, hostWithLocale: this.isPBS ? this.hostWithLocale : this.localeCode, host: this.host, name: this.name, currentNode: this.currentNode, filters: this.filters, filtrationSmartData: this.filtrationSmartData, navigationState: this.nodeOrSubCatId, productList: this.products.map((productInfo) => productInfo).join(), productUrlParams: this.productUrlParams || '', pills: this.pills, categories: this.filtersCategories, productsPerPage: this.getPaginationParamsWithDefaults.productsPerPage, productsCount: this.productsCount, selectedPage: this.selectedPage, isLoading: this.isLoading, isMobileCategorySelected: this.isMobileCategorySelected, showDocuments: this.showDocuments, resultCount: this.resultsCount, firstLoadedRecNum: this.firstLoadedRecNum, lastLoadedRecNum: this.lastLoadedRecNum, richText: this.richText, enableCommerceConnector: this.enableCommerceConnector, showBuyOnline: this.showBuyOnline, selectedSectionsCount: this.selectedSectionsCount, productCtas: this.productCtas, showCompare: !this.isPBS, isPBS: this.isPBS, enableAppRouting: this.isExternalConsumer ? !this.externalAppRoutingEnabled : this.isPBS, isExternalConsumer: this.isExternalConsumer, externalUrlConfig: this.externalUrlConfig, externalFavoriteConfig: this.externalFavoriteConfig, localeCode: this.localeCode, id: this.id, analyticsPageData: this.analyticsPageData }));
    this.renderDocumentListing = (name, isSoftware) => {
      var _a, _b, _c, _d, _e;
      return (!isEmpty(this.tabs.documents) && (h("pes-document-listing", { name: name, apiEndpoint: this.tabs.documents.apiEndpoint, documentDetailsUrl: this.tabs.documents.documentDetailsUrl, enableDocumentDetailsUrl: false, country: getCountry(this.localeCode), language: getLanguage(this.localeCode), pageType: "range", resourceId: this.id, software: isSoftware, view: "smallcard", myFavorites: false, applicationSource: ((_a = this.documentListing) === null || _a === void 0 ? void 0 : _a.appSource) || ((_c = (_b = this.tabs) === null || _b === void 0 ? void 0 : _b.documents) === null || _c === void 0 ? void 0 : _c.appSource), userProfile: (_d = this.documentListing) === null || _d === void 0 ? void 0 : _d.userProfile, idmsToken: (_e = this.documentListing) === null || _e === void 0 ? void 0 : _e.idmsToken })));
    };
    this.renderSoftwareRegistration = () => {
      return (!isEmpty(this.tabs.softwareRegistration) && (h("pes-range-software-registration-tab", { url: this.tabs.softwareRegistration.softwareRegistrationUrl })));
    };
    this.getTabRenderInfoByNames = (tabName) => {
      var _a, _b, _c, _d, _e, _f, _g, _h;
      const productsTab = {
        title: (_b = (_a = this.tabs) === null || _a === void 0 ? void 0 : _a.products) === null || _b === void 0 ? void 0 : _b.title,
        renderFunction: this.renderProductsTab,
        hash: TAB_NAMES.Products,
        hidden: false,
      };
      switch (tabName) {
        case 'products': return ((_d = (_c = this.tabs) === null || _c === void 0 ? void 0 : _c.products) === null || _d === void 0 ? void 0 : _d.showProductsTab) ? productsTab : null;
        case 'presentation': return {
          title: this.rangePresentationLabel,
          renderFunction: (slot) => this.renderPresentationTab(slot),
          slotName: CAASContentOverviewSlotName,
          hash: TAB_NAMES.Presentation,
          hidden: false,
        };
        case 'documents': return {
          title: (_f = (_e = this.tabs) === null || _e === void 0 ? void 0 : _e.documents) === null || _f === void 0 ? void 0 : _f.documentLabel,
          renderFunction: () => this.renderDocumentListing(TAB_NAMES.Documents, false),
          hash: TAB_NAMES.Documents,
          hidden: !this.documentsTabEnabled[TAB_NAMES.Documents],
        };
        case 'software': return {
          title: this.rangeSoftwareAndFirmwareLabel,
          renderFunction: () => this.renderDocumentListing(TAB_NAMES.Software, true),
          hash: TAB_NAMES.Software,
          hidden: !this.documentsTabEnabled[TAB_NAMES.Software],
        };
        case 'softwareRegistration': return {
          title: this.softwareRegistrationLabel,
          renderFunction: this.renderSoftwareRegistration,
          hash: TAB_NAMES.SoftwareRegistration,
          hidden: isEmpty((_g = this.tabs) === null || _g === void 0 ? void 0 : _g.softwareRegistration),
        };
        case 'webinarsAndResources': return {
          title: this.rangeWebinarsAndResourcesLabel,
          renderFunction: this.renderWebinarsAndResources,
          hash: TAB_NAMES.WebinarAndResources,
          hidden: isEmpty((_h = this.tabs) === null || _h === void 0 ? void 0 : _h.webinarsAndResources),
        };
        default:
          return null;
      }
    };
    this.getTabs = (rangeTabs) => {
      const tabs = [];
      for (const key of Object.keys(rangeTabs)) {
        const tabRenderInfo = this.getTabRenderInfoByNames(key);
        if (!tabRenderInfo)
          continue;
        tabs.push(tabRenderInfo);
      }
      return tabs;
    };
    this.host = '';
    this.localeCode = undefined;
    this.productUrlParams = undefined;
    this.endpoint = undefined;
    this.appProductsLabel = undefined;
    this.commonFiltersFilterBy = undefined;
    this.facetButtonResetAllLabel = undefined;
    this.facetButtonViewLessFilters = undefined;
    this.facetButtonViewMoreFilters = undefined;
    this.nextLabel = undefined;
    this.pageLabel = undefined;
    this.noResultsClearLink = undefined;
    this.noResultsHeader = undefined;
    this.noResultsMessage = undefined;
    this.numberProductsOfAllProductsLabel = undefined;
    this.previousLabel = undefined;
    this.rangeProductLabel = undefined;
    this.rangeProductsFiltersLabel = undefined;
    this.viewLessLabel = undefined;
    this.viewMoreLabel = undefined;
    this.viewProductsLabel = undefined;
    this.rangePresentationLabel = undefined;
    this.rangeWebinarsAndResourcesLabel = undefined;
    this.softwareRegistrationLabel = undefined;
    this.rangeSoftwareAndFirmwareLabel = undefined;
    this.loadMoreLabel = undefined;
    this.loadPreviousLabel = undefined;
    this.backLabel = undefined;
    this.descriptionBigger = undefined;
    this.id = undefined;
    this.name = 'TODO';
    this.navigationState = undefined;
    this.rangeReference = undefined;
    this.onProductClick = undefined;
    this.showDocuments = undefined;
    this.tabs = undefined;
    this.enableCommerceConnector = true;
    this.showBuyOnline = true;
    this.currentReference = undefined;
    this.isPBS = false;
    this.seoURl = undefined;
    this.productCtas = undefined;
    this._host = undefined;
    this._localeCode = undefined;
    this._productUrlParams = undefined;
    this._endpoint = undefined;
    this._appProductsLabel = undefined;
    this._commonFiltersFilterBy = undefined;
    this._facetButtonResetAllLabel = undefined;
    this._facetButtonViewLessFilters = undefined;
    this._facetButtonViewMoreFilters = undefined;
    this._nextLabel = undefined;
    this._pageLabel = undefined;
    this._noResultsClearLink = undefined;
    this._noResultsHeader = undefined;
    this._noResultsMessage = undefined;
    this._numberProductsOfAllProductsLabel = undefined;
    this._previousLabel = undefined;
    this._rangeProductLabel = undefined;
    this._rangeProductsFiltersLabel = undefined;
    this._viewLessLabel = undefined;
    this._viewMoreLabel = undefined;
    this._viewProductsLabel = undefined;
    this._rangePresentationLabel = undefined;
    this._rangeWebinarsAndResourcesLabel = undefined;
    this._softwareRegistrationLabel = undefined;
    this._rangeSoftwareAndFirmwareLabel = undefined;
    this._loadMoreLabel = undefined;
    this._loadPreviousLabel = undefined;
    this._descriptionBigger = undefined;
    this._id = undefined;
    this._name = undefined;
    this._navigationState = undefined;
    this._rangeReference = undefined;
    this._showDocuments = undefined;
    this._tabs = undefined;
    this._enableCommerceConnector = undefined;
    this._showBuyOnline = undefined;
    this._currentReference = undefined;
    this._backLabel = undefined;
    this._rangeBanner = undefined;
    this.documentListing = undefined;
    this._externalUrlConfig = undefined;
    this._externalFavoriteConfig = undefined;
    this.isExternalConsumer = undefined;
    this.externalUrlConfig = undefined;
    this.externalFavoriteConfig = undefined;
    this.externalAppRoutingEnabled = undefined;
    this.hostWithLocale = undefined;
    this.analyticsPageData = undefined;
    this.rangeBanner = undefined;
    this.currentNode = undefined;
    this.filters = undefined;
    this.filtersNormalized = undefined;
    this.filtrationSmartData = undefined;
    this.products = [];
    this.productsCount = 0;
    this.resultsCount = undefined;
    this.firstLoadedRecNum = undefined;
    this.filterNodeId = undefined;
    this.lastLoadedRecNum = undefined;
    this.navigationStateBeforeFilterMobileViewOpen = undefined;
    this.baseFilterUrl = undefined;
    this.initialNodeIds = undefined;
    this.isResetFilters = undefined;
    this.selectedPage = undefined;
    this.filtersCategories = [];
    this.isTabsInitialized = false;
    this.isMobileCategorySelected = false;
    this.isLoading = false;
    this.documentsTabEnabled = {
      [TAB_NAMES.Documents]: false,
      [TAB_NAMES.Software]: false,
    };
    this.documentListingApiConfig = undefined;
    this.richText = undefined;
    this.pills = [];
    this.selectedSectionsCount = undefined;
    this.initialfilterUrl = undefined;
    this.selectedFilterUrl = undefined;
    this.nodeIdFromNode = undefined;
    this.nodeIdFromUrl = undefined;
    this.nodeOrSubCatId = undefined;
    this.initialNodeId = undefined;
    this.PBSoffset = 0;
  }
  documentListingReady(event) {
    const { name, hasDocuments } = event.detail;
    this.documentsTabEnabled = Object.assign(Object.assign({}, this.documentsTabEnabled), { [name]: hasDocuments });
  }
  handleNodeSelected(event) {
    var _a, _b, _c;
    const { id, nodeReference } = event.detail;
    this.PBSoffset = 0;
    this.currentNode = calculateCurrentNodeParams({
      nodeReference: this.rangeReference,
      id,
      name: this.name,
      nodes: (_a = this.tabs) === null || _a === void 0 ? void 0 : _a.products.nodes,
    }, join(getLocaleWithV3(this.localeCode, /^[^A-Z]+$/.test(this.localeCode)), rangeBasePath, this.rangeReference), nodeReference, this.backLabel);
    this.filterNodeId = this.currentNode.id;
    this.initialfilterUrl = this.getInitialFiltersUrl;
    const nodeFilterUrl = getRangeFilterUrl(this.filterNodeId, (_c = (_b = this.tabs) === null || _b === void 0 ? void 0 : _b.products) === null || _c === void 0 ? void 0 : _c.filtersUrl, this.localeCode);
    this.loadFilters(nodeFilterUrl);
  }
  onFilterStateChanged(event) {
    const { lastChangedFilterId: filterId } = event.detail;
    if (filterId) {
      const { rootSectionId, seoUrl, checkedURL, unCheckedURL, navigationState, } = this.filtersNormalized.entities.filter[filterId];
      const changedFilterUrl = unCheckedURL !== '' ? unCheckedURL : checkedURL;
      const nodeIdOnFilterChange = navigationState === DEFAULT_NAVIGATION_STATE
        ? this.nodeOrSubCatId
        : navigationState;
      this.changeFilter(changedFilterUrl, nodeIdOnFilterChange, filterReset(changedFilterUrl, this.initialfilterUrl), rootSectionId === 'product.category' ? seoUrl : '');
    }
  }
  onSelectCategoryHandler(event) {
    this.setActive(event.detail);
    this.isMobileCategorySelected = true;
  }
  resetAllFiltersHandler() {
    this.isResetFilters = true;
    this.changeFilter(this.initialfilterUrl, this.initialNodeId, true, join(getLocaleWithV3(this.localeCode, /^[^A-Z]+$/.test(this.localeCode)), 'product-range', this.initialNodeIds.rangePath));
  }
  onToggleMobileViewVisibility(event) {
    const { detail } = event;
    if (detail === null || detail === void 0 ? void 0 : detail.restore) {
      this.setActive(this.navigationStateBeforeFilterMobileViewOpen);
    }
    else if (!detail) {
      this.navigationStateBeforeFilterMobileViewOpen = this.baseFilterUrl;
    }
  }
  removePillHandler(event) {
    const unCheckedURL = event.detail;
    this.changeFilter(unCheckedURL, this.nodeOrSubCatId, filterReset(unCheckedURL, this.initialfilterUrl));
  }
  productClickHandler(event) {
    var _a;
    const productRef = event.detail;
    (_a = this.onProductClick) === null || _a === void 0 ? void 0 : _a.call(this, productRef);
  }
  choosePage(event) {
    this.selectedPage = event.detail;
    const { productsPerPage } = this.getPaginationParamsWithDefaults;
    if (!this.isPBS) {
      setPaginationParams(productsPerPage * (this.selectedPage - 1), productsPerPage, true);
    }
    this.PBSoffset = productsPerPage * (this.selectedPage - 1);
    this.loadProducts(this.selectedFilterUrl);
  }
  mobileCategoryReset() {
    this.isMobileCategorySelected = false;
  }
  trackAnalyticsEventListener(e) {
    const { event } = e.detail;
    if (!event)
      return;
    if (event === FILTER_STATE_CHANGED_EVENT_NAME)
      trackFilterAnalytics(e, this.filtersNormalized);
  }
  changeFilter(changedFilterUrl, nodeId, isReset, seoUrl) {
    if (!this.isPBS) {
      setNavigationFilterPath(changedFilterUrl, nodeId, isReset, seoUrl);
    }
    this.nodeOrSubCatId = getSelectedNodeIdFromUrl(this.initialNodeId);
    this.setActive(changedFilterUrl);
  }
  get activeCategory() {
    var _a, _b;
    const category = (_a = this.filters) === null || _a === void 0 ? void 0 : _a[0];
    return category && ((_b = category.filterRefinements.find((i) => i.checked)) === null || _b === void 0 ? void 0 : _b.label);
  }
  get getPaginationParamsWithDefaults() {
    return getPaginationParams({
      offset: 0,
      productsPerPage: Number(this.tabs.products.numberProductsOnRangePage),
    });
  }
  get getInitialFiltersUrl() {
    var _a, _b, _c;
    if (!((_c = (_b = (_a = this.tabs) === null || _a === void 0 ? void 0 : _a.products) === null || _b === void 0 ? void 0 : _b.nodes) === null || _c === void 0 ? void 0 : _c.length))
      return this.baseFilterUrl;
    if (!this.isPBS && this.initialNodeIds.nodeId) {
      return `${this.baseFilterUrl}&hlnode-id=${this.initialNodeIds.nodeId}`;
    }
    return this.filterNodeId
      ? `${this.baseFilterUrl}&hlnode-id=${this.filterNodeId}`
      : this.baseFilterUrl;
  }
  async loadFilters(filterUrl) {
    this.isLoading = true;
    try {
      const { filtersNormalized, filtrationSmartData, pills, filtersCategories, selectedSectionsCount, filters, } = await fetchSprykerFilters(`${this.host}${filterUrl}`);
      this.filters = filters !== null && filters !== void 0 ? filters : [];
      this.filtersNormalized = filtersNormalized;
      this.filtrationSmartData = filtrationSmartData;
      this.pills = pills !== null && pills !== void 0 ? pills : [];
      this.filtersCategories = filtersCategories;
      this.selectedSectionsCount = selectedSectionsCount > 0 ? selectedSectionsCount : 0;
    }
    catch (error) {
      this.isLoading = false;
      console.error(error);
    }
    finally {
      if (this.isResetFilters) {
        this.isResetFilters = false;
      }
      this.loadProducts(filterUrl);
    }
  }
  loadProducts(filtersUrl) {
    var _a, _b, _c, _d;
    this.isLoading = true;
    const PBSUrl = getPbsFilterProductsUrl({
      host: this.host,
      ProductsPath: (_b = (_a = this.tabs) === null || _a === void 0 ? void 0 : _a.products) === null || _b === void 0 ? void 0 : _b.productsUrl,
      CheckedFiltersUrl: filtersUrl,
      pbsOffset: this.PBSoffset,
      Nrpp: this.tabs.products.numberProductsOnRangePage,
    });
    const PPWUrl = getFilterProductsUrl((_d = (_c = this.tabs) === null || _c === void 0 ? void 0 : _c.products) === null || _d === void 0 ? void 0 : _d.productsUrl, this.tabs.products.numberProductsOnRangePage, this.localeCode, this.filterNodeId, { pageParam: pageParam.RANGE_LISTING, subCategoryId: '' });
    const url = !this.isPBS ? PPWUrl : PBSUrl;
    getData(false, url)
      .then((response) => {
      this.setProductsInfo(response);
    })
      .finally(() => {
      this.isLoading = false;
      this.isTabsInitialized = true;
    });
  }
  setProductsInfo(productsInfo) {
    var _a;
    if (!productsInfo)
      return;
    const { totalNumRecs, firstRecNum, recsPerPage, productIds, richText } = productsInfo;
    this.richText = parseRichText(richText);
    const productsCount = (_a = productIds === null || productIds === void 0 ? void 0 : productIds.length) !== null && _a !== void 0 ? _a : 0;
    const lastRecNum = firstRecNum + productsCount - 1;
    this.productsCount = productsInfo.totalNumRecs;
    this.resultsCount = {
      firstRecNum,
      lastRecNum,
      recsPerPage,
      totalNumRecs,
    };
    if (!isMobile()) {
      this.firstLoadedRecNum = undefined;
      this.lastLoadedRecNum = undefined;
      this.products = [];
    }
    this.firstLoadedRecNum = this.firstLoadedRecNum === undefined
      ? firstRecNum
      : Math.min(firstRecNum, this.firstLoadedRecNum);
    this.lastLoadedRecNum = this.lastLoadedRecNum === undefined
      ? lastRecNum
      : Math.max(lastRecNum, this.lastLoadedRecNum);
    this.products = productIds;
  }
  componentWillLoad() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26;
    if (!isBrowser()) {
      return;
    }
    if (!this.analyticsPageData) {
      this.analyticsPageData = getAnalyticsPageLoadData();
    }
    this.host = (_a = tryParse(this._host)) !== null && _a !== void 0 ? _a : this.host;
    this.localeCode = (_b = tryParse(this._localeCode)) !== null && _b !== void 0 ? _b : this.localeCode;
    this.productUrlParams = (_c = tryParse(this._productUrlParams)) !== null && _c !== void 0 ? _c : this.productUrlParams;
    this.endpoint = (_d = tryParse(this._endpoint)) !== null && _d !== void 0 ? _d : this.endpoint;
    this.appProductsLabel = (_e = tryParse(this._appProductsLabel)) !== null && _e !== void 0 ? _e : this.appProductsLabel;
    this.commonFiltersFilterBy = (_f = tryParse(this._commonFiltersFilterBy)) !== null && _f !== void 0 ? _f : this.commonFiltersFilterBy;
    this.facetButtonResetAllLabel = (_g = tryParse(this._facetButtonResetAllLabel)) !== null && _g !== void 0 ? _g : this.facetButtonResetAllLabel;
    this.facetButtonViewLessFilters = (_h = tryParse(this._facetButtonViewLessFilters)) !== null && _h !== void 0 ? _h : this.facetButtonViewLessFilters;
    this.facetButtonViewMoreFilters = (_j = tryParse(this._facetButtonViewMoreFilters)) !== null && _j !== void 0 ? _j : this.facetButtonViewMoreFilters;
    this.nextLabel = (_k = tryParse(this._nextLabel)) !== null && _k !== void 0 ? _k : this.nextLabel;
    this.pageLabel = (_l = tryParse(this._pageLabel)) !== null && _l !== void 0 ? _l : this.pageLabel;
    this.noResultsClearLink = (_m = tryParse(this._noResultsClearLink)) !== null && _m !== void 0 ? _m : this.noResultsClearLink;
    this.noResultsHeader = (_o = tryParse(this._noResultsHeader)) !== null && _o !== void 0 ? _o : this.noResultsHeader;
    this.noResultsMessage = (_p = tryParse(this._noResultsMessage)) !== null && _p !== void 0 ? _p : this.noResultsMessage;
    this.numberProductsOfAllProductsLabel = (_q = tryParse(this._numberProductsOfAllProductsLabel)) !== null && _q !== void 0 ? _q : this.numberProductsOfAllProductsLabel;
    this.previousLabel = (_r = tryParse(this._previousLabel)) !== null && _r !== void 0 ? _r : this.previousLabel;
    this.rangeProductLabel = (_s = tryParse(this._rangeProductLabel)) !== null && _s !== void 0 ? _s : this.rangeProductLabel;
    this.rangeProductsFiltersLabel = (_t = tryParse(this._rangeProductsFiltersLabel)) !== null && _t !== void 0 ? _t : this.rangeProductsFiltersLabel;
    this.viewLessLabel = (_u = tryParse(this._viewLessLabel)) !== null && _u !== void 0 ? _u : this.viewLessLabel;
    this.viewMoreLabel = (_v = tryParse(this._viewMoreLabel)) !== null && _v !== void 0 ? _v : this.viewMoreLabel;
    this.viewProductsLabel = (_w = tryParse(this._viewProductsLabel)) !== null && _w !== void 0 ? _w : this.viewProductsLabel;
    this.rangePresentationLabel = (_x = tryParse(this._rangePresentationLabel)) !== null && _x !== void 0 ? _x : this.rangePresentationLabel;
    this.rangeWebinarsAndResourcesLabel = (_y = tryParse(this._rangeWebinarsAndResourcesLabel)) !== null && _y !== void 0 ? _y : this.rangeWebinarsAndResourcesLabel;
    this.softwareRegistrationLabel = (_z = tryParse(this._softwareRegistrationLabel)) !== null && _z !== void 0 ? _z : this.softwareRegistrationLabel;
    this.rangeSoftwareAndFirmwareLabel = (_0 = tryParse(this._rangeSoftwareAndFirmwareLabel)) !== null && _0 !== void 0 ? _0 : this.rangeSoftwareAndFirmwareLabel;
    this.loadMoreLabel = (_1 = tryParse(this._loadMoreLabel)) !== null && _1 !== void 0 ? _1 : this.loadMoreLabel;
    this.loadPreviousLabel = (_2 = tryParse(this._loadPreviousLabel)) !== null && _2 !== void 0 ? _2 : this.loadPreviousLabel;
    this.descriptionBigger = (_3 = tryParse(this._descriptionBigger)) !== null && _3 !== void 0 ? _3 : this.descriptionBigger;
    this.id = (_4 = tryParse(this._id)) !== null && _4 !== void 0 ? _4 : this.id;
    this.name = (_5 = tryParse(this._name)) !== null && _5 !== void 0 ? _5 : this.name;
    this.navigationState = (_6 = tryParse(this._navigationState)) !== null && _6 !== void 0 ? _6 : this.navigationState;
    this.rangeReference = (_7 = tryParse(this._rangeReference)) !== null && _7 !== void 0 ? _7 : this.rangeReference;
    this.showDocuments = (_8 = tryParse(this._showDocuments)) !== null && _8 !== void 0 ? _8 : this.showDocuments;
    this.tabs = (_9 = tryParse(this._tabs)) !== null && _9 !== void 0 ? _9 : this.tabs;
    this.enableCommerceConnector = (_10 = tryParse(this._enableCommerceConnector)) !== null && _10 !== void 0 ? _10 : this.enableCommerceConnector;
    this.showBuyOnline = (_11 = tryParse(this._showBuyOnline)) !== null && _11 !== void 0 ? _11 : this.showBuyOnline;
    this.currentReference = (_12 = tryParse(this._currentReference)) !== null && _12 !== void 0 ? _12 : this.currentReference;
    this.externalUrlConfig = (_13 = tryParse(this._externalUrlConfig)) !== null && _13 !== void 0 ? _13 : this.externalUrlConfig;
    this.externalFavoriteConfig = (_14 = tryParse(this._externalFavoriteConfig)) !== null && _14 !== void 0 ? _14 : this.externalFavoriteConfig;
    this.backLabel = (_15 = tryParse(this._backLabel)) !== null && _15 !== void 0 ? _15 : this.backLabel;
    this.rangeBanner = (_16 = tryParse(this._rangeBanner)) !== null && _16 !== void 0 ? _16 : this.rangeBanner;
    if (!this.currentReference) {
      this.currentReference = this.isPBS
        ? this.rangeReference
        : getCurrentReference(Boolean((_19 = (_18 = (_17 = this.tabs) === null || _17 === void 0 ? void 0 : _17.products) === null || _18 === void 0 ? void 0 : _18.nodes) === null || _19 === void 0 ? void 0 : _19.length), rangeBasePath);
    }
    this.currentNode = calculateCurrentNodeParams({
      nodeReference: this.rangeReference,
      id: 'root',
      name: this.name,
      nodes: (_20 = this.tabs) === null || _20 === void 0 ? void 0 : _20.products.nodes,
    }, join(getLocaleWithV3(this.localeCode, /^[^A-Z]+$/.test(this.localeCode)), 'product-range', this.rangeReference), this.currentReference, this.backLabel);
    const { offset, productsPerPage } = this.getPaginationParamsWithDefaults;
    this.selectedPage = Math.floor(offset / productsPerPage) + 1;
    this.nodeIdFromNode = (_21 = this.currentNode) === null || _21 === void 0 ? void 0 : _21.id;
    const segments = window.location.pathname
      .split('/')
      .filter((pathSegment) => pathSegment !== '');
    const pathname = !this.isPBS ? window.location.pathname : this.currentReference;
    this.initialNodeIds = getRangeNodesIds(pathname, this.rangeReference);
    if (this.currentReference === segments[segments.length - 1] && this.nodeIdFromNode) {
      this.filterNodeId = this.nodeIdFromNode;
    }
    else {
      this.filterNodeId = (_22 = this.initialNodeIds) === null || _22 === void 0 ? void 0 : _22.nodeId;
    }
    if (this.navigationState) {
      this.isMobileCategorySelected = true;
    }
    this.initialNodeId = this.navigationState;
    this.nodeOrSubCatId = getSelectedNodeIdFromUrl(this.initialNodeId);
    this.baseFilterUrl = getBaseUrl((_24 = (_23 = this.tabs) === null || _23 === void 0 ? void 0 : _23.products) === null || _24 === void 0 ? void 0 : _24.filtersUrl, this.localeCode);
    this.initialfilterUrl = this.getInitialFiltersUrl;
    this.selectedFilterUrl = getRangeFilterUrl(this.filterNodeId, (_26 = (_25 = this.tabs) === null || _25 === void 0 ? void 0 : _25.products) === null || _26 === void 0 ? void 0 : _26.filtersUrl, this.localeCode);
    this.loadFilters(this.selectedFilterUrl);
    window.addEventListener('popstate', this.handlePopState);
  }
  disconnectedCallback() {
    window.removeEventListener('popstate', this.handlePopState);
  }
  setActive(changedFilterUrl) {
    this.PBSoffset = 0;
    this.selectedPage = 1;
    this.products = [];
    this.selectedFilterUrl = changedFilterUrl;
    this.loadFilters(changedFilterUrl);
  }
  render() {
    if (!this.isTabsInitialized)
      return null;
    const tabs = this.getTabs(this.tabs).filter(Boolean);
    return (h("pes-tabs", { class: "range-tabs", tabs: tabs }, h("slot", { slot: CAASContentOverviewSlotName, name: CAASContentOverviewSlotName })));
  }
  static get is() { return "pes-spryker-range-tabs"; }
  static get originalStyleUrls() {
    return {
      "$": ["pes-spryker-range-tabs.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["pes-spryker-range-tabs.css"]
    };
  }
  static get properties() {
    return {
      "host": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "host",
        "reflect": false,
        "defaultValue": "''"
      },
      "localeCode": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "locale-code",
        "reflect": false
      },
      "productUrlParams": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string | null",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "product-url-params",
        "reflect": false
      },
      "endpoint": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "endpoint",
        "reflect": false
      },
      "appProductsLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "app-products-label",
        "reflect": false
      },
      "commonFiltersFilterBy": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "common-filters-filter-by",
        "reflect": false
      },
      "facetButtonResetAllLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "facet-button-reset-all-label",
        "reflect": false
      },
      "facetButtonViewLessFilters": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "facet-button-view-less-filters",
        "reflect": false
      },
      "facetButtonViewMoreFilters": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "facet-button-view-more-filters",
        "reflect": false
      },
      "nextLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "next-label",
        "reflect": false
      },
      "pageLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "page-label",
        "reflect": false
      },
      "noResultsClearLink": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "no-results-clear-link",
        "reflect": false
      },
      "noResultsHeader": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "no-results-header",
        "reflect": false
      },
      "noResultsMessage": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "no-results-message",
        "reflect": false
      },
      "numberProductsOfAllProductsLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "number-products-of-all-products-label",
        "reflect": false
      },
      "previousLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "previous-label",
        "reflect": false
      },
      "rangeProductLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "range-product-label",
        "reflect": false
      },
      "rangeProductsFiltersLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "range-products-filters-label",
        "reflect": false
      },
      "viewLessLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "view-less-label",
        "reflect": false
      },
      "viewMoreLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "view-more-label",
        "reflect": false
      },
      "viewProductsLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "view-products-label",
        "reflect": false
      },
      "rangePresentationLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "range-presentation-label",
        "reflect": false
      },
      "rangeWebinarsAndResourcesLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "range-webinars-and-resources-label",
        "reflect": false
      },
      "softwareRegistrationLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "software-registration-label",
        "reflect": false
      },
      "rangeSoftwareAndFirmwareLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "range-software-and-firmware-label",
        "reflect": false
      },
      "loadMoreLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "load-more-label",
        "reflect": false
      },
      "loadPreviousLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "load-previous-label",
        "reflect": false
      },
      "backLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "back-label",
        "reflect": false
      },
      "descriptionBigger": {
        "type": "boolean",
        "mutable": true,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Range bigger description."
        },
        "attribute": "description-bigger",
        "reflect": false
      },
      "id": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Range id."
        },
        "attribute": "id",
        "reflect": false
      },
      "name": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "name",
        "reflect": false,
        "defaultValue": "'TODO'"
      },
      "navigationState": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "navigation-state",
        "reflect": false
      },
      "rangeReference": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "range-reference",
        "reflect": false
      },
      "onProductClick": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "(productRef: string) => void",
          "resolved": "(productRef: string) => void",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "showDocuments": {
        "type": "boolean",
        "mutable": true,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "If show Documents CTA and documents list in product-card"
        },
        "attribute": "show-documents",
        "reflect": false
      },
      "tabs": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TRangeTabs",
          "resolved": "{ products?: TProductsTab; presentation?: PresentationData; documents?: TDocumentListing; softwareRegistration?: TSoftwareRegistrationData; webinarsAndResources?: TWebinarAndResourcesData; }",
          "references": {
            "TRangeTabs": {
              "location": "import",
              "path": "../product-range/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "enableCommerceConnector": {
        "type": "boolean",
        "mutable": true,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "enable-commerce-connector",
        "reflect": false,
        "defaultValue": "true"
      },
      "showBuyOnline": {
        "type": "boolean",
        "mutable": true,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "show-buy-online",
        "reflect": false,
        "defaultValue": "true"
      },
      "currentReference": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "current-reference",
        "reflect": false
      },
      "isPBS": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-p-b-s",
        "reflect": false,
        "defaultValue": "false"
      },
      "seoURl": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "seo-u-rl",
        "reflect": false
      },
      "productCtas": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TProductCtas",
          "resolved": "{ buttons: TProductCtasButtons; productProp?: string; }",
          "references": {
            "TProductCtas": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Setup productCtas logic.\nbuttons - predefined CTA buttons.\nproductProp - predefined property of product to find in list."
        }
      },
      "_host": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-host",
        "reflect": false
      },
      "_localeCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-locale-code",
        "reflect": false
      },
      "_productUrlParams": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-product-url-params",
        "reflect": false
      },
      "_endpoint": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-endpoint",
        "reflect": false
      },
      "_appProductsLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-app-products-label",
        "reflect": false
      },
      "_commonFiltersFilterBy": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-common-filters-filter-by",
        "reflect": false
      },
      "_facetButtonResetAllLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-facet-button-reset-all-label",
        "reflect": false
      },
      "_facetButtonViewLessFilters": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-facet-button-view-less-filters",
        "reflect": false
      },
      "_facetButtonViewMoreFilters": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-facet-button-view-more-filters",
        "reflect": false
      },
      "_nextLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-next-label",
        "reflect": false
      },
      "_pageLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-page-label",
        "reflect": false
      },
      "_noResultsClearLink": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-no-results-clear-link",
        "reflect": false
      },
      "_noResultsHeader": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-no-results-header",
        "reflect": false
      },
      "_noResultsMessage": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-no-results-message",
        "reflect": false
      },
      "_numberProductsOfAllProductsLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-number-products-of-all-products-label",
        "reflect": false
      },
      "_previousLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-previous-label",
        "reflect": false
      },
      "_rangeProductLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-range-product-label",
        "reflect": false
      },
      "_rangeProductsFiltersLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-range-products-filters-label",
        "reflect": false
      },
      "_viewLessLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-view-less-label",
        "reflect": false
      },
      "_viewMoreLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-view-more-label",
        "reflect": false
      },
      "_viewProductsLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-view-products-label",
        "reflect": false
      },
      "_rangePresentationLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-range-presentation-label",
        "reflect": false
      },
      "_rangeWebinarsAndResourcesLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-range-webinars-and-resources-label",
        "reflect": false
      },
      "_softwareRegistrationLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-software-registration-label",
        "reflect": false
      },
      "_rangeSoftwareAndFirmwareLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-range-software-and-firmware-label",
        "reflect": false
      },
      "_loadMoreLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-load-more-label",
        "reflect": false
      },
      "_loadPreviousLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-load-previous-label",
        "reflect": false
      },
      "_descriptionBigger": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-description-bigger",
        "reflect": false
      },
      "_id": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-id",
        "reflect": false
      },
      "_name": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-name",
        "reflect": false
      },
      "_navigationState": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-navigation-state",
        "reflect": false
      },
      "_rangeReference": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-range-reference",
        "reflect": false
      },
      "_showDocuments": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-show-documents",
        "reflect": false
      },
      "_tabs": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-tabs",
        "reflect": false
      },
      "_enableCommerceConnector": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-enable-commerce-connector",
        "reflect": false
      },
      "_showBuyOnline": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-show-buy-online",
        "reflect": false
      },
      "_currentReference": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-current-reference",
        "reflect": false
      },
      "_backLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-back-label",
        "reflect": false
      },
      "_rangeBanner": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-range-banner",
        "reflect": false
      },
      "documentListing": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "Partial<DDCProps>",
          "resolved": "{ documentLabel?: string; softwareAndFirmwareLabel?: string; productId?: string; apiEndpoint?: string; documentDetailsUrl?: string; localeCode?: string; idmsToken?: string; myDocumentsAddedLabel?: string; myDocumentsRemovedLabel?: string; myDocumentsUrl?: string; myDocumentsCta?: string; showMyDocuments?: boolean; appSource?: string; userProfile?: string; }",
          "references": {
            "Partial": {
              "location": "global"
            },
            "DDCProps": {
              "location": "import",
              "path": "../../globals/ddc"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "_externalUrlConfig": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-external-url-config",
        "reflect": false
      },
      "_externalFavoriteConfig": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-external-favorite-config",
        "reflect": false
      },
      "isExternalConsumer": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Defines consumer is external-user"
        },
        "attribute": "is-external-consumer",
        "reflect": false
      },
      "externalUrlConfig": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TExternalUrlConfig",
          "resolved": "{ viewDetail: string[]; substitution: string[]; }",
          "references": {
            "TExternalUrlConfig": {
              "location": "import",
              "path": "../../globals/external-consumer"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Defines customized url(s) of hyperlink for external-user"
        }
      },
      "externalFavoriteConfig": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TExternalFavoritelConfig",
          "resolved": "{ host: string; localeCode: string; }",
          "references": {
            "TExternalFavoritelConfig": {
              "location": "import",
              "path": "../../globals/external-consumer"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Defines favorite configuration for external-user"
        }
      },
      "externalAppRoutingEnabled": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Enable app-routing for external-user"
        },
        "attribute": "external-app-routing-enabled",
        "reflect": false
      },
      "hostWithLocale": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "hostWithLocale contains host, countryCode and languageCode"
        },
        "attribute": "host-with-locale",
        "reflect": false
      },
      "analyticsPageData": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "MetaTags['analyticsPageData']",
          "resolved": "{ articleTitle: string | number; businessUnit: string; pageRangeId: string; pageSubCategoryId: string; pageCategoryId: string; pageSubCategory: string; pageProductId: string; fromWebView: boolean; digitalPlatform: string; digitalPlatformCountry: string; pageLanguage: string; environment: string; template: string; pageSubSubCategory: string; pageTopCategory: string; pageCategory: string; pageTitle: string; }",
          "references": {
            "MetaTags": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "rangeBanner": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "MarketingBannerData",
          "resolved": "MarketingBannerData",
          "references": {
            "MarketingBannerData": {
              "location": "import",
              "path": "../reusable/marketing-banner/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      }
    };
  }
  static get states() {
    return {
      "currentNode": {},
      "filters": {},
      "filtersNormalized": {},
      "filtrationSmartData": {},
      "products": {},
      "productsCount": {},
      "resultsCount": {},
      "firstLoadedRecNum": {},
      "filterNodeId": {},
      "lastLoadedRecNum": {},
      "navigationStateBeforeFilterMobileViewOpen": {},
      "baseFilterUrl": {},
      "initialNodeIds": {},
      "isResetFilters": {},
      "selectedPage": {},
      "filtersCategories": {},
      "isTabsInitialized": {},
      "isMobileCategorySelected": {},
      "isLoading": {},
      "documentsTabEnabled": {},
      "documentListingApiConfig": {},
      "richText": {},
      "pills": {},
      "selectedSectionsCount": {},
      "initialfilterUrl": {},
      "selectedFilterUrl": {},
      "nodeIdFromNode": {},
      "nodeIdFromUrl": {},
      "nodeOrSubCatId": {},
      "initialNodeId": {},
      "PBSoffset": {}
    };
  }
  static get elementRef() { return "el"; }
  static get listeners() {
    return [{
        "name": "documentListingReady",
        "method": "documentListingReady",
        "target": undefined,
        "capture": false,
        "passive": false
      }, {
        "name": "nodeSelected",
        "method": "handleNodeSelected",
        "target": undefined,
        "capture": false,
        "passive": false
      }, {
        "name": "filterStateChanged",
        "method": "onFilterStateChanged",
        "target": undefined,
        "capture": false,
        "passive": false
      }, {
        "name": "selectCategory",
        "method": "onSelectCategoryHandler",
        "target": undefined,
        "capture": false,
        "passive": false
      }, {
        "name": "resetAllClicked",
        "method": "resetAllFiltersHandler",
        "target": undefined,
        "capture": false,
        "passive": false
      }, {
        "name": "toggleMobileView",
        "method": "onToggleMobileViewVisibility",
        "target": undefined,
        "capture": false,
        "passive": false
      }, {
        "name": "removePill",
        "method": "removePillHandler",
        "target": undefined,
        "capture": false,
        "passive": false
      }, {
        "name": "productClick",
        "method": "productClickHandler",
        "target": undefined,
        "capture": false,
        "passive": false
      }, {
        "name": "pageSelected",
        "method": "choosePage",
        "target": undefined,
        "capture": false,
        "passive": false
      }, {
        "name": "headerCategoryClick",
        "method": "mobileCategoryReset",
        "target": undefined,
        "capture": false,
        "passive": false
      }, {
        "name": "track_analytics",
        "method": "trackAnalyticsEventListener",
        "target": undefined,
        "capture": false,
        "passive": false
      }];
  }
}
